import { useEffect, useState } from 'react';
import { Modal } from '../ui/Modal.jsx';
import { documentsApi, DOCUMENT_TYPES } from '../../api/documents.js';

export function DocumentForm({ open, onClose, carId, preTip, onCreated }) {
  const [tip, setTip] = useState(preTip || 'RCA');
  const [dataEmitere, setDataEmitere] = useState('');
  const [dataExpirare, setDataExpirare] = useState('');
  const [observatii, setObservatii] = useState('');
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  // Sincronizează tip-ul când se deschide cu un tip preselectat
  useEffect(() => {
    if (open) setTip(preTip || 'RCA');
  }, [open, preTip]);

  function reset() {
    setTip(preTip || 'RCA');
    setDataEmitere('');
    setDataExpirare('');
    setObservatii('');
    setFile(null);
    setErr('');
    setBusy(false);
  }

  async function onSubmit(e) {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('car_id', carId);
      fd.append('tip', tip);
      if (dataEmitere) fd.append('data_emitere', dataEmitere);
      if (dataExpirare) fd.append('data_expirare', dataExpirare);
      if (observatii) fd.append('observatii', observatii);
      if (file) fd.append('fisier', file);

      const res = await documentsApi.create(fd);
      onCreated?.(res.document);
      reset();
      onClose?.();
    } catch (ex) {
      if (ex.body?.error === 'invalid_mime') setErr('Fișier invalid — doar PDF, JPEG sau PNG.');
      else if (ex.body?.error === 'file_too_large') setErr('Fișier peste 10MB.');
      else if (ex.body?.error === 'validation_error') setErr('Date invalide.');
      else setErr(ex.body?.error || 'Eroare.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Adaugă document">
      <form onSubmit={onSubmit} className="space-y-4">
        {err && <div className="rounded-lg border border-danger/30 bg-danger/10 px-3 py-2 text-sm text-danger">{err}</div>}

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Tip</span>
          <select
            value={tip}
            onChange={(e) => setTip(e.target.value)}
            className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
          >
            {DOCUMENT_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </label>

        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted">Data emitere</span>
            <input
              type="date"
              value={dataEmitere}
              onChange={(e) => setDataEmitere(e.target.value)}
              className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
            />
          </label>
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted">Data expirare</span>
            <input
              type="date"
              value={dataExpirare}
              onChange={(e) => setDataExpirare(e.target.value)}
              className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
            />
          </label>
        </div>
        <p className="text-xs text-muted">Pentru talon / carte auto lasă expirarea goală.</p>

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Observații (opțional)</span>
          <textarea
            rows={2}
            value={observatii}
            onChange={(e) => setObservatii(e.target.value)}
            className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
          />
        </label>

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Fișier (PDF/JPEG/PNG, max 10MB)</span>
          <input
            type="file"
            accept="application/pdf,image/jpeg,image/png"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="mt-1 block text-sm"
          />
        </label>

        <div className="flex justify-end gap-2">
          <button type="button" onClick={() => { reset(); onClose?.(); }} className="btn-ghost">Anulează</button>
          <button type="submit" disabled={busy} className="btn-primary">
            {busy ? 'Se salvează…' : 'Adaugă'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
